module.exports = __webpack_public_path__ + "img/whatsapp.ec69d1fa.png";